import { Button, Col, Row } from 'antd';
import { useEffect, useState } from 'react';

import styles from './billing-cards.module.scss';
import { Card } from 'modules/profile/models/Cards';
import ProfileBillingCardItemComponent from '../billing-card-item/billing-card-item';

function ProfileBillingCardsComponent() {
	const cards: Card[] = [
		{
			name: 'Moemen Said',
			expire: new Date(),
			type: 'Visa',
			number: 2345,
			isPrimary: true,
		},
		{
			name: 'Mohamed Ahmed',
			expire: new Date(),
			type: 'Mastercard',
			number: 2543,
			isPrimary: false,
		},
	];

	return (
		<>
			<div className="sectionContainer titled">
				<header>Payment Methods</header>
				<main>
					<h6 className="mb-4">My Cards</h6>

					<Row gutter={[20, 20]}>
						{cards.map((card, i) => (
							<Col span={24} md={12} key={i}>
								<ProfileBillingCardItemComponent card={card} />
							</Col>
						))}

						<Col span={24} md={12}>
							<div className={styles.addCardDiv}>
								<div>
									<h6>Important Note!</h6>
									<p className="mb-0">
										Please carefully read <a href="#">Product Terms</a> adding your new payment card
									</p>
								</div>
								<Button type="primary">Add card</Button>
							</div>
						</Col>
					</Row>
				</main>
			</div>
		</>
	);
}

export default ProfileBillingCardsComponent;
